module.exports = __webpack_public_path__ + "img/icon25.aacda2bd.png";